import React from 'react';
import { CssBaseline } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import GlobalStyle from './styles/global';
import Layout from './components/Layout';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { parseISO } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import RegrasJuros from './pages/RegrasJuros';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Emprestimos from './pages/Emprestimos';
import Pagamentos from './pages/Pagamentos';
import FluxoCaixa from './pages/FluxoCaixa';
import NotificacoesHistorico from './pages/NotificacoesHistorico';
import ConfiguracoesNotificacao from './pages/ConfiguracoesNotificacao';
import Login from './pages/Login';
import Logs from './pages/Logs';
import Usuarios from './pages/Usuarios';
import RelatorioJurosPagos from './pages/Relatorios/JurosPagos';
import RelatorioAtrasados from './pages/Relatorios/RelatorioAtrasados';

const theme = createTheme({
  typography: {
    fontFamily: 'Poppins, sans-serif',
  },
  palette: {
    primary: {
      main: '#1a237e',
    },
    secondary: {
      main: '#4a148c',
    },
  },
});

// Estendendo o AdapterDateFns para lidar com strings de data
class CustomDateAdapter extends AdapterDateFns {
  parse(value, format) {
    if (typeof value === 'string') {
      return parseISO(value);
    }
    return super.parse(value, format);
  }
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={CustomDateAdapter} adapterLocale={ptBR}>
        <AuthProvider>
          <CssBaseline />
          <GlobalStyle />
          <BrowserRouter>
            <Routes>
              {/* Rota pública */}
              <Route path="/login" element={<Login />} />

              {/* Rotas protegidas */}
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Layout>
                      <Outlet />
                    </Layout>
                  </PrivateRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="clientes" element={<Clientes />} />
                <Route path="regras-juros" element={<RegrasJuros />} />
                <Route path="emprestimos" element={<Emprestimos />} />
                <Route path="pagamentos" element={<Pagamentos />} />
                <Route path="fluxo-caixa" element={<FluxoCaixa />} />
                <Route path="relatorios/juros-pagos" element={<RelatorioJurosPagos />} />
                <Route path="relatorios/atrasados" element={<RelatorioAtrasados />} />
                <Route path="notificacoes/historico" element={<NotificacoesHistorico />} />
                <Route path="notificacoes/configuracoes" element={<ConfiguracoesNotificacao />} />
                <Route path="logs" element={<Logs />} />
                <Route path="usuarios" element={<Usuarios />} />
              </Route>

              {/* Redireciona qualquer rota não encontrada para o login */}
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </BrowserRouter>
        </AuthProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;